<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {changeLanguage} from "@/api";

function toApiLang(appLang) {
  if (appLang === 'en') return 'en_US'
  return 'zh_CN'
}

export default {
  name: 'App',
  components: {},
  methods: {
    handleVisibilityChange() {
      if (document.hidden) {
        console.log('页面隐藏');
      } else {
        const lang = sessionStorage.getItem('lang') || this.$i18n.locale
        sessionStorage.setItem('lang', lang)
        changeLanguage(toApiLang(lang))

      }
    }
  },
  created() {
    const lang = sessionStorage.getItem('lang')
    if (!lang) {
      const currentLang = this.$i18n.locale
      sessionStorage.setItem('lang', currentLang)
      changeLanguage(toApiLang(currentLang)).then(() => {
        location.reload()
      })
    } else {
      changeLanguage(toApiLang(lang))
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

  },
//  关闭则删除缓存
  beforeDestroy() {
    sessionStorage.removeItem('lang');
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);

  }
}
</script>

<style lang="scss">
html {
  overflow-x: hidden;
}

@font-face {
  font-family: 'Alibaba-PuHuiTi-Medium';
  src: url('./assets/Alibaba-PuHuiTi-Medium.ttf') format('truetype');
}

@font-face {
  font-family: 'Alibaba PuHuiTi';
  src: url('./assets/Alibaba-PuHuiTi-Regular.ttf') format('truetype');
}

@font-face {
  font-family: 'OPPOSans';
  src: url("./assets/OPPOSans-M.ttf") format('truetype');
}

body {
  margin: 0;
  width: 100% !important;

}

body::-webkit-scrollbar {
  width: 8px !important;
}

body::-webkit-scrollbar-track {
  background: #f1f1f1;
}

body::-webkit-scrollbar-thumb {
  background: #1C277F;
  border-radius: 3px;
}

#app {
  @media (max-width: 1600px) {
    //overflow-x: hidden!important;
    ::-webkit-scrollbar {
      //width: 0!important;
      //height: 0!important;
    }
  }
}
</style>
